import { render, staticRenderFns } from "./EndElement.vue?vue&type=template&id=3a283f72&scoped=true&"
import script from "./EndElement.vue?vue&type=script&lang=js&"
export * from "./EndElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a283f72",
  null
  
)

export default component.exports